var React = require('react');

function CheckboxChecked (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.30344 6.8139L0 8.88321L5.92214 15.4802L16.7025 1.92814L14.2751 0L5.78097 10.6805L2.30344 6.8139Z","fill":"#00B905"}));
}

CheckboxChecked.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = CheckboxChecked;

CheckboxChecked.default = CheckboxChecked;
